import { ShoppingCart } from '../contexts/application-state-context';
import { getReservationPrices } from './product';

export function totalFromCart(cart: ShoppingCart) {
  return cart.reduce((acc, item) => {
    return acc + getReservationPrices(item).totalPriceWithDiscount;
  }, 0);
}
